// src/Components/Drawer/PhotosTab/PhotosTabMenu.js

import React from 'react';
import { Box, IconButton } from '@mui/material';
import {
  MenuAddNew,
  MenuAddNewGrey,
  MenuSave,
  MenuSaveGrey,
  MenuDelete,
  MenuDeleteGrey,
  MenuIconCancel,
  MenuIconCancelGrey,
} from '../../../assets/icons/CustomIcons';

export default function PhotosTabMenu({
  handleHeaderAction,
  selectedMarker,
  isDirty,
  isAppFullScreen,
}) {
  const toolBlockStyle = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minWidth: 0,
  };

  const ICON_SIZE = 64; // Retained original icon size

  // AMENDED: Strictly check for a real marker (id or isNew) to ignore the empty tempData placeholder
  const isSelected = !!(selectedMarker && (selectedMarker.id || selectedMarker.isNew));

  const enableSave = isSelected && isDirty;

  // AMENDED: Cancel should always be active if a marker is selected (to close the drawer) or if in full screen
  const enableCancel = isSelected || isAppFullScreen;

  // Squashed the clickable focus area into a sleek rectangle that fits the 45px bar
  const buttonSx = {
    p: 0,
    height: '38px',
    width: '60px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' },
    // Shifts the oversized SVG up by 8px to reveal the text cut off at the bottom
    '& svg': { transform: 'translateY(-8px)' },
  };

  return (
    <Box
      sx={{
        height: '100%', // Fills the 45px wrapper
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '5px',
        paddingRight: '5px',
      }}>
      {/* 1. ADD PHOTO */}
      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!isSelected}
          onClick={() => handleHeaderAction('ADD')}>
          {isSelected ? (
            <MenuAddNew sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuAddNewGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      {/* 2. SAVE BUTTON */}
      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!enableSave}
          onClick={() => handleHeaderAction('SAVE')}>
          {enableSave ? (
            <MenuSave sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuSaveGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      {/* 3. DELETE BUTTON */}
      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!isSelected}
          onClick={() => handleHeaderAction('DELETE')}>
          {isSelected ? (
            <MenuDelete sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuDeleteGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>

      {/* 4. CLOSE BUTTON */}
      <Box sx={toolBlockStyle}>
        <IconButton
          sx={buttonSx}
          disabled={!enableCancel}
          onClick={() => handleHeaderAction('CLOSE')}>
          {enableCancel ? (
            <MenuIconCancel sx={{ fontSize: ICON_SIZE }} />
          ) : (
            <MenuIconCancelGrey sx={{ fontSize: ICON_SIZE }} />
          )}
        </IconButton>
      </Box>
    </Box>
  );
}
